import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-708455d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "story-highlights" }
const _hoisted_2 = { class: "story-highlight" }
const _hoisted_3 = { class: "story-highlight-content" }
const _hoisted_4 = { class: "story-highlight-title" }
const _hoisted_5 = { class: "story-highlight-text" }

import { PropType } from 'vue';

import OptimizedImage from '../OptimizedImage.vue';
import { HighlightedStoriesBlock } from '@functions/model/content';


export default /*#__PURE__*/_defineComponent({
  __name: 'HighlightedStoriesBlock',
  props: {
  block: {
    type: Object as PropType<HighlightedStoriesBlock>,
    required: true
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.block.stories, (story, index) => {
      return (_openBlock(), _createBlock(_component_router_link, {
        class: "story-highlight-link",
        to: `/verhaal/${story.id}`,
        key: index
      }, {
        default: _withCtx(() => [
          _createElementVNode("article", _hoisted_2, [
            _createVNode(OptimizedImage, {
              class: "story-highlight-image",
              width: 400,
              image: story.image
            }, null, 8, ["image"]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h3", _hoisted_4, _toDisplayString(story.title), 1),
              _createElementVNode("p", _hoisted_5, "Lees het verhaal " + _toDisplayString(story.person ? `van ${story.person}` : undefined), 1)
            ])
          ])
        ]),
        _: 2
      }, 1032, ["to"]))
    }), 128))
  ]))
}
}

})